import * as MyKeysApi from './index';
import * as DTypes from '../../../modules/devicetypes';
import { buildCriteraList } from './searchCriteria';
import { setReadRights, resetReadRights } from './devices';
import { GroupCriteriaDto, CustomerInfo } from '../../../models';
import { MyKeysPromise } from './interfaces';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const searchPage = (
  pageIdx: number,
  state: DTypes.State
): Promise<any> => {
  const requestBatch = state.data.pageSize;

  const criteria = buildCriteraList(state.filters, state.sort);
  const body = {
    groupCriteria: GroupCriteriaDto.DeviceName,
    criteria,
    pageIndex: pageIdx - 1,
    pageSize: requestBatch,
  };

  Logger.info(
    ['POST: Order Search Requested', state, body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/GetGroupList', body, true)
    .then((res) => MyKeysApi.Map.mapDTypeGroupListDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const assingReadRights = (
  customer: CustomerInfo,
  keys: string[]
): MyKeysPromise<boolean> => {
  const criteria = DTypes.getCriteria(keys);
  return setReadRights([], [], criteria, customer);
};

export const removeReadRights = (keys: string[]): MyKeysPromise<boolean> => {
  const criteria = DTypes.getCriteria(keys);
  return resetReadRights([], [], criteria);
};
